import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { Box, Card, Tab, Tabs } from "@mui/material";
import a11yProps from "../../helpers/ay-props";
import React, { useEffect } from "react";

import TabPanel from "../../helpers/TabPanel";
import WorklogGeneralReport from "./WorklogGeneralReport";
import TasksAndProjectsReportPage from "./TasksAndProjectsReportPage";
import TabBoxComponent from "components/UI/TabBox";

const ProjectGeneralReport = ({
    location,
    SetSelectedMenu,
    GetAllResources,
}) => {
    const [tabValue, setTabValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    useEffect(() => {
        SetSelectedMenu({
            menu: "all-report",
            title: "Reports Page",
        });
        GetAllResources();
    }, []);

    return (
        <Card>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                {/* <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    aria-label="basic tabs example">

                    <Tab label={"General Report "} {...a11yProps(0)} />
                    <Tab label={"Worklog Report "} {...a11yProps(1)} />

                </Tabs> */}
                <TabBoxComponent
                    selectedValue={tabValue}
                    handleTabChange={handleChange}
                    tabList={[
                        {
                            label: "General Report",
                            tabValue: 0,
                            permissionCode: "menu.task.management",
                        },
                        {
                            label: "Worklog Report",
                            tabValue: 1,
                            permissionCode: "submenu.report.worklog",
                        },
                    ]}
                />

                <TabPanel index={0} value={tabValue} p={1}>
                    <TasksAndProjectsReportPage
                        location={location}
                        SetSelectedMenu={SetSelectedMenu}
                        loggedUser={null}
                    />
                </TabPanel>
                <TabPanel index={1} value={tabValue} p={2}>
                    <WorklogGeneralReport
                        location={location}
                        SetSelectedMenu={SetSelectedMenu}
                        loggedUser={null}
                    />
                </TabPanel>
            </Box>
        </Card>
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProjectGeneralReport);